function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 3h8v2H5v14h14v-6h2v8H3V3zm14.586 2H14V3h7v7h-2V6.414l-6.293 6.293-1.414-1.414L17.586 5z",
  fill: "currentColor"
});

var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#B4BBFF"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iI0I0QkJGRiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zIDNINEgxMVY1SDVWMTlIMTlWMTNIMjFWMjBWMjFIMjBINEgzVjIwVjRWM1pNMTcuNTg1OCA1SDE0VjNIMjBIMjFWNFYxMEgxOVY2LjQxNDIxTDEyLjcwNzEgMTIuNzA3MUwxMS4yOTI5IDExLjI5MjlMMTcuNTg1OCA1WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { SvgLink as ReactComponent };